import digit from './core/digit/index';
import { Effect } from './core/digit/effect';

const { transform, process, DigitImageData, } = digit;
export default {
  transform,
  process,
  DigitImageData,
  Effect,
};